import { Bell, FileText, AlertCircle, Zap } from 'lucide-react'

import type { Notification } from '@/types/api/notification'

interface NotificationIconProps {
  type: Notification['type']
}

export function NotificationIcon({ type }: NotificationIconProps) {
  switch (type) {
    case 'WORKSPACE_INVITE':
      return <Bell className="h-5 w-5 text-primary-500" />

    case 'PUBLIC_FORM_SUBMISSION':
      return <FileText className="h-5 w-5 text-primary-500" />

    case 'FOLLOWUPS_DUE_SUMMARY':
      return <AlertCircle className="h-5 w-5 text-orange-500" />

    case 'AUTOMATION':
      return <Zap className="h-5 w-5 text-emerald-500" />

    default:
      return <Bell className="h-5 w-5 text-neutral-400" />
  }
}